import React from 'react'
import Box from '@node-space/storybook-components/dist/Box'
import { Skeleton } from '@node-space/storybook-components/dist/SkeletonLoader'

const CustomerWalletsSkeletonLoader = () => {
  return (
    <Box flex direction="col" gapY={8} paddingB={20}>
      <Box>
        <Skeleton className="w-full h-10 bg-gray" variant="input" />
      </Box>
      <Box>
        <Box border="gray">
          <Box background="gray-03" className="animate-pulse w-full h-10 bg-gray border-0" />
          {new Array(5).fill(null).map((item, index) => (
            <Box
              key={index}
              paddingX={16}
              paddingY={20}
              flex
              alignItems="center"
              direction="row"
              gapX={16}
              border="gray"
            >
              <Box width="full" flex direction="row">
                <Box background="gray-03" borderRadius={'full'} width={32} height={32} />
                <Box flexSize="fill" paddingL={12}>
                  <Skeleton className="w-32 h-4" variant="text" />
                  <Skeleton className="w-24 h-4 mt-2" variant="text" />
                </Box>
                <Box alignItems="center" className="pr-28" flex>
                  <Skeleton className="w-16 h-4 border-8" variant="text" />
                </Box>
              </Box>
              <Box className="px-4 w-1/3.5">
                <Skeleton className="w-2 h-8 border-8" variant="text" />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default CustomerWalletsSkeletonLoader
